import React from 'react';
import {RaisedButton, Snackbar} from "material-ui";
import {Link, withRouter} from "react-router-dom";
import {trim} from "lodash";
import {validateEmail} from "../helpers";
import {createSubscriber} from "../actions/lead";
import {connect} from "react-redux";
import JdData from './JdData'

class Career extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            data: ''
        };
    }

    onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    }
    
    onSubmit = async (e) => {
        e.preventDefault();
        const currentPath = trim(`${window.location.pathname}`,'/')
        const page = currentPath ? currentPath : 'home'
        if (await this.validate()) {
            const body = {
                email: this.state.email,
                subscription_for: page
            };
            this.setState({disabled: true});
            const res = await this.props.createSubscriber(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value
        });
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        return validateFlag;
    }

    render() {
        return (
            <div>
                <section className="hero-area">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6 order-lg-2">
                                <div className="hero-image">
                                    <img src="images/ascendcap_career_jobs.jpg"/>
                                </div>
                            </div>
                            <div className="col-lg-6 order-lg-1">
                                <div className="hero-content">
                                    <h1>Together At Ascend Capital</h1>
                                    <p>
                                    We at Ascend Capital are building next level fintech platform. If you are a geek, sales hustler, growth hacker or can wear multiple hats then this is the place for you.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="hero-area">
                    <div className="container">
                        <div className="perks">
                            <h3>Perks and Benefits</h3>
                        </div>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-3">
                                <div className="feature-card perks">
                                <div className="card-icon"><i className="far fa-clock"></i></div>
                                <p>Flexible Working Hours</p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="feature-card perks">
                                <div className="card-icon"><i className="fas fa-book"></i></div>
                                <p>eBooks</p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="feature-card perks">
                                <div className="card-icon"><i className="fas fa-laptop-code"></i></div>
                                <p>MacBooks for everyone</p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="feature-card perks">
                                <div className="card-icon"><i className="fas fa-hamburger"></i></div>
                                <p>Food & Snacks</p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-3">
                                <div className="feature-card perks">
                                    <div className="card-icon"><i className="fas fa-money-check-alt"></i></div>
                                    <p>Generous Compensation & Equity</p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="feature-card perks">
                                    <div className="card-icon"><i className="fas fa-hand-peace"></i></div>
                                    <p>Amazing Peers</p>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="feature-card perks">
                                    <div className="card-icon"><i className="fas fa-child"></i></div>
                                    <p>5 Lacs Medical Insurance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
                    <div className="container career">
                        <div className="job-search">
                            <h4>Current Openings</h4>
                        </div>
                        {/* <div className="row job-details align-items-center">
                            <div className="col-md-4">
                                <h5>{`Position : ${jdData[0].position}`}</h5>
                            </div>
                            <div className="col-md-8">
                                <p style={{ fontSize: 20 }}>{`Department : ${jdData[0].department}`}</p>
                            </div>
                            <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                                <div>
                                    <p style={{marginBottom: '10px', fontSize: '20px'}}>Job Description :</p>
                                    <ul style={{paddingLeft: '30px'}}>
                                        <li ><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData[0].bullet_point_1}`}</span></li>
                                        <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData[0].bullet_point_2}`}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right', paddingRight: '10px', marginLeft: '100px', marginTop: '100px' }}>
                                <RaisedButton
                                    style={{
                                        width: '100',
                                        height: '40',
                                        fontSize: '16'
                                    }}
                                    className = 'submit-btn'
                                    type= "SUBMIT"
                                    label = 'Apply'
                                    labelColor = '#ffffff'
                                    backgroundColor = '#925a94'
                                />
                            </div>
                        </div> */}
                        {/* <div className="row job-details align-items-center">
                            <div className="col-md-4">
                                <h5>{`Position : ${jdData[1].position}`}</h5>
                            </div>
                            <div className="col-md-8">
                                <p style={{ fontSize: 20 }}>{`Department : ${jdData[1].department}`}</p>
                            </div>
                            <div style={{ textAlign: 'justify', paddingLeft: '35px', marginBottom: 'auto', maxWidth: '80%' }}>
                                <div>
                                    <p style={{marginBottom: '10px', fontSize: '20px'}}>Job Description :</p>
                                    <ul style={{paddingLeft: '30px'}}>
                                        <li ><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData[1].bullet_point_1}`}</span></li>
                                        <li style={{marginTop: '10px', marginBottom: '20px'}}><span style={{fontSize: 14}}>&bull;</span> <span style={{fontSize: '16px'}}>{`${jdData[1].bullet_point_2}`}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right', paddingRight: '10px', marginLeft: '100px', marginTop: '100px' }}>
                                <Link to={`/job_description/${jdData[1].jd_id}`} ><RaisedButton
                                    style={{
                                        width: '100',
                                        height: '40',
                                        fontSize: '16'
                                    }}
                                    className = 'submit-btn'
                                    type= "SUBMIT"
                                    label = 'Apply'
                                    labelColor = '#ffffff'
                                    backgroundColor = '#925a94'
                                /></Link> 
                            </div>
                        </div> */}
                        {JdData.map((job, index) => (
                            <div className="row job-details align-items-center" key={index}>
                                <div className="col-md-6">
                                    <h5 style={{textAlign:'start'}}>{`Position : ${job.position}`}</h5>
                                </div>
                                <div className="col-md-6">
                                    <p style={{ fontSize: 20, textAlign : 'end' }}>{`Department : ${job.department}`}</p>
                                </div>
                                <div className="col-md-12" style={{display:'flex', flexDirection : 'row', justifyContent:'space-between'}}>
                                    <div style={{display:'flex', flexDirection:'column', alignItems:'start', maxWidth:'80%'}}>
                                        <p style={{marginBottom: '5px', fontSize: '20px'}}>Job Description :</p>
                                        <ul className='jd_descrip' style={{display:'flex', flexDirection:'column', alignItems:'start', marginLeft:30, listStyle:'disc', textAlign:'justify', lineHeight:'1.3rem'}}>
                                            <li style={{marginTop:10, fontSize:16}}>{`${job.bullet_point_1}`}</li>
                                            <li style={{marginTop:10, fontSize:16}}>{`${job.bullet_point_2}`}</li>
                                        </ul>
                                    </div>
                                    <div style={{display:'flex', alignItems:'center'}}>
                                        <Link to={`/job_description/${job.jd_id}`} >
                                            <RaisedButton
                                                style={{
                                                    width: '100',
                                                    height: '40',
                                                    fontSize: '16'
                                                }}
                                                className = 'submit-btn'
                                                type= "SUBMIT"
                                                label = 'Apply'
                                                labelColor = '#ffffff'
                                                backgroundColor = '#925a94'
                                            />
                                        </Link> 
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(Career))



// WEBPACK FOOTER //
// ./src/components/Career.js